/**
 * Factbox - functionality
 */

window.TV2 = window.TV2 || {};

/**
 * Toggle / collapse text
 * @param id
 */
window.TV2.toggleFactbox = (id) => {
  const factbox = document.getElementById(`factbox-${id}`);
  const factboxButton = factbox.querySelector(".factbox__button");

  factbox.classList.toggle("factbox--expanded");

  // Set aria-tags on expandable menu
  if (factbox.classList.contains("factbox--expanded")) {
    factboxButton.setAttribute("aria-expanded", "true");
  } else {
    factboxButton.setAttribute("aria-expanded", "false");
  }
};
